import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const LEGACY_EMPLOYEE_ATTENDANCE_KEYS = new Set([
  "missed_shifts", "unclassified_missed_shifts", "called_out_sick_shifts",
  "called_out_other_shifts", "no_call_no_show_shifts", "manager_cancelled_shifts",
]);
const baseKey = (key) => key.replace(/_previous_year$/, "");

export default function MetricDefinitions({ selectedMetrics = [], metrics = [] }) {
  const [open, setOpen] = React.useState(false);
  const keys = selectedMetrics.map(baseKey);
  const legacyEmployeeAttendance = keys.some((key) => LEGACY_EMPLOYEE_ATTENDANCE_KEYS.has(key));
  const definitions = [...new Map(metrics
    .filter((metric) => keys.includes(baseKey(metric.value)) && metric.description)
    .map((metric) => [baseKey(metric.value), metric])).values()];
  if (!legacyEmployeeAttendance && definitions.length === 0) return null;
  const label = legacyEmployeeAttendance
    ? "Metric definitions: legacy employee totals may differ from store totals"
    : "Metric definitions";
  return <>
    <div className="flex shrink-0 justify-end pb-1">
      <Tooltip title={label}>
        <IconButton aria-label={label} onClick={() => setOpen(true)} size="small"
          sx={{ color: "#6d28d9", bgcolor: "white" }}>
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth
      // Match Rovis's ManageShortcutsModal layer above its floating/fullscreen panel (1400).
      sx={{ zIndex: 1500 }}
      aria-labelledby="report-metric-definitions-title">
      <DialogTitle id="report-metric-definitions-title">Metric definitions</DialogTitle>
      <DialogContent dividers>
        {legacyEmployeeAttendance && <p className="mb-4 text-sm text-slate-600">
          For past date ranges, these legacy employee attendance counts exclude the
          requested end date and use direct punch matching. Store attendance measures
          include the end date and split-shift coverage, so totals in separate reports
          may differ.
        </p>}
        <dl className="space-y-3 text-sm text-slate-600">
          {definitions.map((metric) => <div key={metric.value}>
            <dt className="font-medium">{metric.label}</dt>
            <dd>{metric.description}</dd>
          </div>)}
        </dl>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => setOpen(false)}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            borderColor: "#6d28d9",
            color: "#6d28d9",
            "&:hover": {
              borderColor: "#5b21b6",
              backgroundColor: "#f3f4f6",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  </>;
}
